import React from 'react';
import { Box, Container, Typography, Divider, Link as MuiLink, Grid } from '@mui/material';
import { colors } from '../styles/theme';

function Footer() {
  return (
    <Box component="footer" sx={{
      backgroundColor: colors.primary.dark,
      color: 'rgba(255,255,255,0.85)',
      mt: 'auto',
    }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={4}>
          {/* 项目信息 */}
          <Grid item xs={12} md={4}>
            <Typography sx={{
              fontWeight: 700, fontSize: '1rem', mb: 1.5,
              fontFamily: '"Noto Serif SC", serif', color: 'white',
            }}>
              中文热词国际新闻报道检索系统
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.8, opacity: 0.8 }}>
              基于 LexisNexis 数据库，系统收录了 2014-2025 年间
              73 个中文热词在国际主流媒体中的 197,479 条新闻语料，
              涵盖情感分析、主题分类与媒体来源追踪。
            </Typography>
          </Grid>

          {/* 数据说明 */}
          <Grid item xs={12} md={4}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.9rem', mb: 1.5, color: 'white' }}>
              数据说明
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
              {[
                '数据来源：LexisNexis Academic',
                '时间跨度：2014 - 2025',
                '语料规模：197,479 条',
                '热词数量：73 个（每年约 10 个）',
                '分析维度：情感、主题、媒体来源',
              ].map((text) => (
                <Typography key={text} variant="body2" sx={{ opacity: 0.75, fontSize: '0.82rem' }}>
                  {text}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* 联系方式 */}
          <Grid item xs={12} md={4}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.9rem', mb: 1.5, color: 'white' }}>
              关于
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.75, lineHeight: 1.8, fontSize: '0.82rem' }}>
              本系统由研究团队开发，用于学术研究与教学。
              如有数据引用需求，请注明数据来源。
            </Typography>
            <MuiLink
              href="/about"
              sx={{
                color: colors.secondary.light, fontSize: '0.85rem',
                mt: 1.5, display: 'inline-block',
                textDecorationColor: 'rgba(212,184,74,0.4)',
                '&:hover': { color: colors.secondary.main },
              }}
            >
              了解更多 &rarr;
            </MuiLink>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.12)' }} />

        <Box sx={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 1,
        }}>
          <Typography variant="caption" sx={{ opacity: 0.5 }}>
            &copy; {new Date().getFullYear()} Chinese Buzzwords in International News Database
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.5 }}>
            仅供学术研究使用
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
